import compareVersions from 'compare-versions';
import { ios_version } from 'src/stores/session/native-bridge';
import { get } from 'svelte/store';

const dwTYpes = ['SBDW-002C', 'SBDW-002D', 'SHDW-1', 'SHDW-2', 'SBDW-103C', 'SBDW-203C', 'SBDW-302C'];

const supportedDevicesBefore133 = (el) => {
	return ['relay', 'light', 'roller', 'diffuser'].includes(el.category);
};

const supportedDevicesAfter133 = (el) => {
	return (
		['relay', 'light', 'roller', 'emeter', 'diffuser'].includes(el.category) ||
		dwTYpes.includes(el.type)
	);
};

export function supportedCarPlayDevices(array) {
	return array.filter((el) =>
		compareVersions.compare(get(ios_version), '1.3.3', '>=')
			? supportedDevicesAfter133(el)
			: supportedDevicesBefore133(el),
	);
}
